import React from "react";
import OutputFactory from "../OutputFactory";

function CollapseView(index, object, fields, actions, onClickItem, fieldImage) {
  return (
    <>
      <div className="d-flex">
        {fieldImage && (
          <div
            className="mb-3"
            style={{
              width: "100px",
              height: "100px",
            }}
          >
            <img
              className="w-100 h-100"
              style={{ objectFit: "cover" }}
              src={object[fieldImage]}
              alt="User Profile"
            />
          </div>
        )}
        <ul className="list-unstyled ms-1">
          {Object.keys(fields).map((field) => {
            const options = fields[field];
            if (options._type === "Image") return null;
            if (options.detail) return null;
            const output = (
              <OutputFactory field={field} object={object} {...options} />
            );
            if (!output) return null;

            return (
              <li key={field}>
                <span className="pe-2 fs-sm opacity-75">
                  {options.label || field}:{" "}
                </span>
                <span className="fs-sm fw-medium text-nowrap text-primary">
                  {output}
                </span>
              </li>
            );
          })}
        </ul>
      </div>
      <div className="d-flex flex-row gap-2">
        {actions ? (
          actions(object.status).map((action) => (
            <button
              key={action.label}
              className={`btn btn-primary btn-sm ${action.classes}`}
              style={{ paddingInline: ".7rem", paddingBlock: ".4rem" }}
              onClick={() => action.onClick(index)}
            >
              {action.icon ? <i class={`${action.icon} pe-2`}></i> : null}
              {action.label}
            </button>
          ))
        ) : (
          <button
            className="btn btn-primary btn-sm"
            onClick={() => onClickItem(index)}
            style={{ paddingInline: ".7rem", paddingBlock: ".4rem" }}
          >
            EDIT
          </button>
        )}
      </div>
    </>
  );
}

export default CollapseView;
